import React, { useState, useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoadingSpinner from "./Components/loader";
import LoginPage from "./Components/login";
import DashboardPage from "./Components/dashboard";
import UserRegistrationDetails from "./pages/userregistrationdetails";
import DetailPage from "./pages/UserDetailPage";
import DashboardHome from "./pages/home";
import PrivateRoute from "./Components/PrivateRoute";
import SongMainTypeMaster from "./pages/songmaintype";
import SongMainTypeList from "./pages/songmaintypetable";
import SongSubTypeForm from "./pages/songsubtype";
import SongSubTypeList from "./pages/songsubtypelist";
import SongCategoryForm from "./pages/songcategory";
import SongCategoryList from "./pages/songcategorylist";
import SongMasterForm from "./pages/songmaster";
import SongMasterList from "./pages/songmasterlist";
import AddBannerForm from "./pages/addbanner";
import AddBannerList from "./pages/addbannerlist";
import AddImgForm from "./pages/addimg";
import AddImgList from "./pages/addimglist";
import AddPdfForm from "./pages/addpdf";
import AddPdfList from "./pages/addpdflist";
import RejectedList from "./pages/rejectedlist";
import PackageExpiredUserList from "./pages/packageexpired";
import PendingList from "./pages/pendinglist";
import DeviceChangeDetails from "./pages/devicechange";
import PackageExpiringSoonList from "./pages/packageexpiringsoon";
import UserDetails from "./pages/deviceuserdetails";
import HomeBannerList from "./pages/homebannerlist";
import HomeBannerForm from "./pages/homebanner";
import ForgetpasswordList from "./pages/forgetpassword";
import PdfCategoryList from "./pages/categorylist";
import AddPdfCategoryForm from "./pages/addpdfcategory";


function App() {
  const [loading, setLoading] = useState(true);
 const [position, setPosition] = useState("top-right"); 

  useEffect(() => {
    const updatePosition = () => {
      if (window.innerWidth <= 768) {
        setPosition("top-center"); 
      } else {
        setPosition("top-right");  
      }
    };

    updatePosition(); 
    window.addEventListener("resize", updatePosition);

    return () => window.removeEventListener("resize", updatePosition);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <LoadingSpinner />;

  return (
    <>
      <Router>
        <Routes>
          
          <Route path="/" element={<LoginPage />} />

         
          <Route element={<PrivateRoute />}>
            <Route path="/dashboard/*" element={<DashboardPage />}>
              <Route index element={<DashboardHome />} />
              <Route path="home" element={<DashboardHome />} />
                 <Route path="rejected" element={<RejectedList />} />
               <Route path="expired" element={<PackageExpiredUserList/>} />
               <Route path="pending" element={<PendingList/>} />
               <Route path="forgetpassword" element={<ForgetpasswordList/>} />
                <Route path="devicechange" element={<DeviceChangeDetails/>} />
                <Route path="expiringsoon" element={<PackageExpiringSoonList />} />
                 <Route path="userdetails/:id" element={<UserDetails />} />
              <Route
                path="userregistration-list"
                element={<UserRegistrationDetails />}
              />
              <Route path="userregistration/:id" element={<DetailPage />} />
               <Route path="maintype" element={<SongMainTypeMaster />} />         
    <Route path="maintype/:id" element={<SongMainTypeMaster />} />     
    <Route path="maintypelist" element={<SongMainTypeList />} />

    <Route path="subtype" element={<SongSubTypeForm />} />  
    <Route path="subtype/:id" element={<SongSubTypeForm />} />     
    <Route path="subtypelist" element={<SongSubTypeList/>} />

    <Route path="category" element={<SongCategoryForm />} />
    <Route path="category/:id" element={<SongCategoryForm />} />     
    <Route path="categorylist" element={<SongCategoryList/>} />  

     <Route path="songmaster" element={<SongMasterForm />} />
     <Route path="songmaster/:id" element={<SongMasterForm />} />     
    <Route path="songmasterlist" element={<SongMasterList/>} />  
    <Route path="addbanner" element={<AddBannerForm/>} />
     <Route path="addbanner/:id" element={<AddBannerForm/>} />     
    <Route path="addbannerlist" element={<AddBannerList/>} />  

    <Route path="addimg" element={<AddImgForm/>} />
     <Route path="addimg/:id" element={<AddImgForm/>} />     
    <Route path="addimglist" element={<AddImgList/>} />  

    <Route path="addpdf" element={<AddPdfForm/>} />
     <Route path="addpdf/:id" element={<AddPdfForm/>} />     
    <Route path="addpdflist" element={<AddPdfList/>} />  

    <Route path="homebannerlist" element={<HomeBannerList />} />
<Route path="homebanner" element={<HomeBannerForm />} />
<Route path="homebanner/:id" element={<HomeBannerForm />} />

  <Route path="pdfcategorylist" element={<PdfCategoryList />} />
<Route path="pdfcategory" element={<AddPdfCategoryForm />} />
<Route path="pdfcategory/:id" element={<AddPdfCategoryForm/>} />

            </Route>
          </Route>

          
          <Route path="*" element={<LoginPage />} />
        </Routes>
      </Router>

      
      <Toaster
      position={position}
      reverseOrder={false}
      toastOptions={{
        style: {
          background: "#1e1e2f",
          color: "#fff",
          borderRadius: "10px",
          padding: "12px 16px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
          fontSize: "14px",
        },
        success: { style: { background: "#22c55e", color: "#fff" } },
        error: { style: { background: "#ef4444", color: "#fff" } },
        loading: { style: { background: "#2563eb", color: "#fff" } },
      }}
    />
    </>
  );
}

export default App;
